import { IFrameMessageListener, IFrameMessageSender } from './iframe.transport';
import { WidgetCommunicator } from './widget_communicator';
import { ajaxRequest } from './ajax';
import { parseUrl } from './url';
import addingCustomPartnerStyles from './addingCustomPartnerStyles';

const widgetContainer = document.getElementById('widget-container');

const iframeID = parseUrl(decodeURIComponent(window.location.href)).params?.script_id;

const { debug, mode, widget_info_string, city_id, city_url, city_name, slug, city_widgetbar_text } =
  widgetContainer.dataset;

const params = {
  mode,
  widget_info_string,
  city_id,
  city_url,
  city_name,
  slug,
  city_widgetbar_text,
};

const loaderMessageListener = new IFrameMessageListener(iframeID);
const loaderMessageSender = new IFrameMessageSender(iframeID, window.parent);
const widgetCommunicator = new WidgetCommunicator(iframeID, params, loaderMessageListener, loaderMessageSender, debug);

function observerInit(element, callback) {
  let timeoutId;

  if (element.__isObserved) {
    return;
  }

  const observer = new IntersectionObserver(
    ([{ isIntersecting }]) => {
      if (isIntersecting) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          callback({ isIntersecting });
          observer.unobserve(element);
          delete element.__isObserved;
        }, 500);
      } else {
        clearTimeout(timeoutId);
      }
    },
    {
      threshold: 0.1,
    },
  );

  observer.observe(element);
  element.__isObserved = true;
}

const decodeTempFix = (src) => src.replace('%&', '%25&');
const iframe = document.body;
const scriptParams = parseUrl(decodeTempFix(window.location.href)).params;
const soguUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://sogu.tripster.ru/events/'
    : 'https://sogu-staging.sogu.dev.tripster.tech/events/';

const commonSoguParams = {
  // app_version: 'widget-ssr-v2',
  app_version: 'experiment',
  user_id: null,
  group: 'ssr-v2',
  platform: 'web',
  dt: +new Date() / 1000,
  url: scriptParams?.siteUrl,
  user_agent: window?.navigator.userAgent ?? '',
  params: {
    widget_id: scriptParams?.script_id,
    source: params.mode,
    count: scriptParams?.num,
    features: scriptParams?.features,
    country: scriptParams?.country,
    partner: scriptParams?.partner,
    region: scriptParams?.region,
    city: scriptParams?.city,
    view: scriptParams?.view,
    template: scriptParams?.template,
    src: scriptParams.src,
    url: scriptParams?.siteUrl,
  },
};

// fn добавление кастомных стилей партнеров
addingCustomPartnerStyles(commonSoguParams);

// iframe observer
observerInit(iframe, () => {
  const expIds = Array.from(document.getElementsByClassName('expcard'), (card) => card.dataset.id);

  ajaxRequest('POST', soguUrl, [
    {
      ...commonSoguParams,
      event_name: 'partner_widget:experiences.view',
      params: {
        ...commonSoguParams.params,
        experience_ids: [...new Set(expIds)] || [],
      },
    },
  ]);
});

// experience snippet observer
[...document.getElementsByClassName('expcard')].forEach((snippet) => {
  observerInit(snippet, () => {
    ajaxRequest('POST', soguUrl, [
      {
        ...commonSoguParams,
        event_name: 'partner_widget:item.view',
        params: {
          ...commonSoguParams.params,
          experience_id: snippet.dataset.id,
          is_paid: snippet.dataset.ispaid === 'true',
          is_replacement: snippet.dataset.is_replacement === 'true',
        },
      },
    ]);
  });
});

const sendWidgetClickEvent = (soguParams) => {
  const soguData = [
    {
      ...commonSoguParams,
      event_name: 'partner_widget:experiences.click',
      params: {
        ...commonSoguParams.params,
        ...soguParams,
      },
    },
  ];
  loaderMessageSender.send('partner_widget:experiences.click', soguData);
  ajaxRequest('POST', soguUrl, soguData);
};

const expCards = document.querySelectorAll('.expcard');
expCards.forEach((el) => {
  el.addEventListener('click', () => {
    sendWidgetClickEvent({
      click_type: 'exp',
      experience_id: el.dataset.id,
      is_paid: el.dataset.ispaid === 'true',
      is_replacement: el.dataset.is_replacement === 'true',
    });
  });
});

const title = document.querySelector('.exp-row__title-link');
if (title) {
  title.addEventListener('click', () => {
    sendWidgetClickEvent({
      click_type: 'title',
    });
  });
}

const logo = document.querySelector('.exp-row__title-logo');
if (logo) {
  logo.addEventListener('click', () => {
    sendWidgetClickEvent({
      click_type: 'logo',
    });
  });
}

const btn = document.querySelector('.exp-button-wrap');
if (btn) {
  btn.addEventListener('click', () => {
    sendWidgetClickEvent({
      click_type: 'btn',
    });
  });
}

/**
 * Пересчет высоты заголовка и описания для карточек виджетов
 */
document.querySelectorAll('div[data-ref=title-container]').forEach((el) => {
  const titleContainerHeight = el.offsetHeight;
  const titleContainerLineHeight = parseInt(window.getComputedStyle(el).getPropertyValue('line-height'));
  const expId = el.dataset.expId;

  const linesCount = Math.round((titleContainerHeight ?? titleContainerLineHeight) / titleContainerLineHeight);

  document.querySelector(`span[data-ref=description-container-${expId}]`).style['-webkit-line-clamp'] = 4 - linesCount;
});

/**
 * cлушаем события от виджетбара
 */
loaderMessageListener.listen('trackWidget', (data) => {
  const soguData = [
    {
      ...commonSoguParams,
      event_name: `partner_widget:${data.action}`,
      params: {
        ...commonSoguParams.params,
        ...data,
      },
    },
  ];

  ajaxRequest('POST', soguUrl, soguData);
});

widgetCommunicator.start();
loaderMessageListener.startListening();
